<template>
  <div class="view-container">
    <section class="section-container" v-if="arrTabs.length">
      <TabComponent 
        :tabItems="arrTabs"
        @changeValue="setTabName" />
      <TableComponent
        :tableData="table"
        :data="table.data"
        :isFilter="true"
        @onRowSelected="setSelectedProducts">
        <div slot="table-top" class="row top-button-container">
          <div>
            <PublishUnpublishComponent
              :selectedProducts="selectedProducts"
              @onDataUpdate="updateDataTable" />
          </div>
          <div>
            <ProductDialogComponent
              @updateDataTable="updateDataTable"
              :sectionName="familyName"
              ref="productDialog" />
          </div>
          <div>
            <button class="btn" @click="exportProducts">
              Export
            </button>
          </div>
        </div>
      </TableComponent>
    </section>
    <ConfirmationComponent
      :isOpen="isOpen"
      :isInfo="isInfo"
      :confirmName="!isInfo ? 'Delete' : 'Close'"
      @confirm="deleteProduct">
      <div v-if="!isInfo" slot="header"><b>Delete {{ product.name }}</b></div>
      <div v-else slot="header"><b>Product {{ product.name }} is being used on the Family Layout!</b></div>
      <div v-if="!isInfo" slot="content" class="body">Are you sure you want to delete the product {{ product.name }}?</div>
      <div v-else slot="content" class="body">Remove the product ortho image from the Family Layout before deleting the product.</div>
    </ConfirmationComponent>
  </div>
</template>

<script>
import ContainerComponent from '../ContainerComponent.vue';
import TableComponent from './TableComponent.vue';
import ProductApiService from '../../services/productApiService';
import TabComponent from '../base.component/TabComponent.vue';
import { Dropdown } from '@eds/vanilla';
import DropdownComponent from '../base.component/DropdownComponent.vue';
import ProductDialogComponent from './ProductDialogComponent.vue';
import { ALL_PRODUCTS } from '../../constants/adminProduct';
import ProductService from '@/services/productService';
import PublishUnpublishComponent from './PublishUnpublishComponent.vue';
import ConfirmationComponent from '../base.component/ConfirmationComponent.vue';

export default {
  components: {
    ContainerComponent,
    TableComponent,
    TabComponent,
    DropdownComponent,
    ProductDialogComponent,
    PublishUnpublishComponent,
    ConfirmationComponent
  },

  data() {
    return {
      table: {},
      arrTabs: [],
      familyName: '',
      dropdowns: DropdownComponent,
      delete: {},
      edit: {},
      createDuplicate: {},
      selectedProducts: [],
      product: {},
      isOpen: false,
      isInfo: false
    };
  },

  async created() {
    await ProductApiService.getProductFamilies();
    this.arrTabs = [...ProductService.getFamiliesForTab()];

    this.arrTabs.unshift({
      name: ALL_PRODUCTS,
      isActive: false
    });

    this.familyName = ALL_PRODUCTS;

    this.initDataTable();
  },

  watch: {
    familyName: function () {
      if (this.familyName === ALL_PRODUCTS) {
        this.table.data = this.mapDataForTable(ProductService.getProducts());
      } else {
        this.table.data = this.mapDataForTable(ProductService.getFamilyProducts());
      }
    },
  },

  methods: {
    initDataTable() {
      let dropdowns = [];
      this.table = {
        data: this.mapDataForTable(ProductService.getProducts()),
        columns: [
          {
            key: 'productId',
            title: 'ID',
            searchable: false,
            sort: 'asc'
          },
          {
            key: 'name',
            title: 'Name',
            searchable: true,
            sort: 'asc'
          },
          {
            key: 'family',
            title: 'Family',
            searchable: true,
            sort: 'asc',
            filter: true
          },
          {
            key: 'group',
            title: 'Group',
            searchable: false,
            sort: 'asc',
            filter: true
          },
          {
            key: 'cluster',
            title: 'Cluster',
            searchable: false,
            type: 'text',
            sort: 'asc',
            filter: true
          },
          {
            key: 'parentName',
            title: 'Parent',
            searchable: false,
            sort: 'asc'
          },
          {
            key: 'benefits',
            title: 'Benefits',
            searchable: false,
            cellStyle: 'padding: 10px',
          },
          {
            key: 'isPublished',
            title: 'Publish status',
            searchable: false,
            onCreatedCell: (td, data) => {
              let content = `
              <kbd class="tag big ${ data ? 'green' : 'red' }">
                ${ data ? 'Published' : 'Unpublished' }
              </kbd>`;
              td.innerHTML = content;
            },
            sort: 'asc',
            filter: true
          }
        ],
        onCreatedActionsCell: (td, data) => {
          if (!data.isPublished) {
            const dropdownDOM = this.createActionMenu();
            td.append(dropdownDOM);

            const dropdown = new Dropdown(dropdownDOM);
            dropdown.init();

            this.delete.addEventListener('click', () => {
              this.isInfo = this.isUsedOnFamily(data);
              this.isOpen = !this.isOpen;
              this.product = data;
            });
            this.edit.addEventListener('click', () => this.editProduct(data));
            this.createDuplicate.addEventListener('click', () => this.duplicateProduct(data));
            dropdowns.push(dropdown);
          } else {
            const dropdownDOM = this.createActionMenuOnlyDuplicate();
            td.append(dropdownDOM);

            const dropdown = new Dropdown(dropdownDOM);
            dropdown.init();

            this.createDuplicate.addEventListener('click', () => this.duplicateProduct(data));
            dropdowns.push(dropdown);
          }
        },
        beforeCreatedBody: () => {
          dropdowns.forEach((d) => d.destroy());
          dropdowns = [];
        },
        selectable: 'multi',
        sortable: true,
        height: '75vh',
        expandable: true,
        onCreatedDetailsRow: (td, data) => {
          let content = '<div style="display: flex">';
          
          content += '<div style="width: 50%"><h3>Specifications:</h3>'
          data['specifications'].forEach((item) => {
            if (item.value) {
              content += `
                <div style="display: flex">
                  <p style="text-decoration: underline;width: 18%">${item?.name}:</p>
                  <p>${item.value}</p>
                </div>`;
            } else {
                let value = item.arrayValue.join(', ');
                content += `
                <div style="display: flex">
                  <p style="text-decoration: underline;width: 18%">${item?.name}:</p>
                  <p>${value}</p>
                </div>`;
            }
          });
          content += '</div>'
          content += `
            <div style="width: 50%">
              <h3>Assets:</h3>
              <div style="display: flex;">
                <p style="text-decoration: underline;width: 10%">3D model:</p>
                <p>${data.modelFileName ?? '-'}</p>
              </div>
              <div style="display: flex;">
                <p style="width: 10%;text-decoration: underline;">Image:<p>
                <p>${data.landscapeImagePath ?? '-'}</p>
              </div>
              <div style="display: flex;">
                <p style="text-decoration: underline;width: 10%">Datasheet:</p>
                <p>${data.dataSheetFilePath ?? '-'}</p>
              </div>
              <div style="display: flex;">
                <p style="text-decoration: underline;width: 10%">Video:</p>
                <p>${data.video?.fileName ?? '-'}</p>
              </div>
              <div style="display: flex;">
                <p style="text-decoration: underline;width: 10%">Colorcode: </p>
                <p>${data.colorCodeImagePath ?? '-'}</p>
              </div>
              <div style="display: flex;">
                <p style="text-decoration: underline;width: 10%">Ortho: </p>
                <p>${data.orthoPath ?? '-'}</p>
              </div>
              <div style="display: flex;">
                <p style="text-decoration: underline;width: 10%">Slides:</p>
                <p>${data.slides == '' ? '-' : data.slides}</p>
              </div>
            </div>
              `
          content += '</div>'
          td.innerHTML = content;
        }
      };
    },

    async updateDataTable() {
      if(this.familyName != ALL_PRODUCTS) {
        await ProductApiService.getProductsByFamily(this.familyName);
      }
      
      await ProductApiService.get();
      
      this.table.data = this.familyName != ALL_PRODUCTS 
        ? ProductService.getFamilyProducts()
        : ProductService.getProducts();
    },

    createActionMenu() {
      const markup = `
      <div class="dropdown more" data-type="click">
        <button class="btn clickable"><i class="icon icon-more"></i></button>
        <div class="menu right">
          <div id="edit" class="item">Edit</div>
          <div id="duplicate" class="item">Duplicate</div>
          <div id="delete" class="item">Delete</div>
        </div>
      </div>`;

      const template = document.createElement('template');
      template.innerHTML = markup.trim();

      this.delete = template.content.getElementById('delete');
      this.edit = template.content.getElementById('edit');
      this.createDuplicate = template.content.getElementById('duplicate');

      return template.content.firstChild;
    },

    createActionMenuOnlyDuplicate() {
      const markup = `
      <div class="dropdown more" data-type="click">
        <button class="btn clickable"><i class="icon icon-more"></i></button>
        <div class="menu right">
          <div id="duplicate" class="item">Duplicate</div>
        </div>
      </div>`;

      const template = document.createElement('template');
      template.innerHTML = markup.trim();
      this.createDuplicate = template.content.getElementById('duplicate');

      return template.content.firstChild;
    },

    editProduct(data) {
      const dialog = this.$refs.productDialog;
      const children = dialog.$el.children;

      dialog.isEdit = true;
      dialog.product = structuredClone(data);

      children[0].click();
    },

    duplicateProduct(data) {
      const dialog = this.$refs.productDialog;
      const children = dialog.$el.children;

      dialog.isDuplicate = true;
      dialog.product = structuredClone(data);

      children[0].click();
    },

    async setTabName(name) {
      if (name != ALL_PRODUCTS) {
        await ProductApiService.getProductsByFamily(name);

        ProductService.getProductFamilies().forEach((item) => {
          if (name == item) {
          this.familyName = item;
          }
        });
      } else {
        this.familyName = name;
        await ProductApiService.get();
      }
      
    },

    async deleteProduct() {
      await ProductApiService.delete(this.product.id);
      await this.updateDataTable();
    },

    setSelectedProducts(arr) {
      this.selectedProducts = arr;
    },
    
    async exportProducts() {
      const exportFile = await ProductApiService.getProductsExportFile(this.familyName);
      const contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

      const byteCharacters = atob(exportFile.data);
      const byteArrays = [];

      for (let i = 0; i < byteCharacters.length; i++) {
          byteArrays.push(byteCharacters.charCodeAt(i));
      }

      const byteArray = new Uint8Array(byteArrays);
      const blob = new Blob([byteArray], { type: contentType });
      
      const filename = `${this.familyName === ALL_PRODUCTS ? 'All ' : this.familyName + ' '}Products.${exportFile.extension}`;

      if (!window.navigator.msSaveBlob) {
        const link = document.createElement('a');
        
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        link.click();
        
        URL.revokeObjectURL(link.href);
      } else {
        window.navigator.msSaveBlob(blob, filename);
      }
    },

    mapDataForTable(products) {
      const mapProducts = products.map(product => {
        return {
          ...product,
          parentName: product.parentId != null ? products.find(pr => pr.id === product.parentId)?.name : ''
        }
      });

      return mapProducts;
    },

    isUsedOnFamily(product) {
      const families = this.$localStorage.get('allFamilyPreview');
      const family = families.find(family => family.familyNameId === product?.sectionName);

      return family?.familyProducts.map(p => p.productId).includes(product.productId);
    }
  },
};
</script>

<style lang="less" scoped>
@import '~@eds/vanilla/variables/global.less';

.view-container {
  overflow: scroll;
  padding-top: 0.25rem;
}

.section-container {
  padding: @space-base @space-large;
}

.top-button-container {
  display: flex;
  align-items: baseline;
}
</style>